<template>
  <el-popover
    style="display: flex"
    v-model="popoverVisible"
    placement="bottom-start"
    width="228"
    trigger="click"
  >
    <div class="date-popover">
      <div>
        <div class="popover-title">选择日期</div>
        <el-button
          type="default"
          class="mb16"
          @click="pickerVisible = !pickerVisible"
        >
          <div class="flex-start align-center">
            <i class="iconfont f18 mr4" style="line-height: 29px">&#xe6c0;</i>
            <span>{{ tempDateValue }}</span>
          </div>
        </el-button>
        <div class="popover-title">快捷日期</div>
        <div class="flex-between align-center flex-wrap">
          <div
            v-for="(item, index) in quickPickerItems"
            :key="item.name"
            class="quick-picker-item"
            :class="{ 'active-quick-picker': activeQuickPicker === index }"
            @click="quickPickDate(item.flag, item.value, index)"
          >
            {{ item.name }}
            <!-- 为了兼容今日实时和昨日，不能用index和value来判断渲染提示文本，改用name -->
            <el-tooltip
              effect="dark"
              placement="top"
              :enterable="false"
              v-if="item.name === '今日实时' || item.name === '今天'"
            >
              <div slot="content">
                <template>
                  实时数据仅做参考，到晚上转钟后会对实时数据过滤(比如过滤<br />重复点击/扣费/无效购买等)，精准数据请查看明日直通车报表
                </template>
                <!-- <template v-else>
                  历史分日汇总的成交数据可能与直通车后台存在一定的<br />偏差，这是因为当天点击浏览后过了N天之后才购买
                </template> -->
              </div>
              <i class="iconfont ml4">&#xe6cb;</i>
            </el-tooltip>
          </div>
        </div>
        <div class="flex-end mt8">
          <el-button type="primary" @click="submitPickResult">确定</el-button>
          <el-button type="default" @click="popoverVisible = false"
            >取消</el-button
          >
        </div>
      </div>
      <div v-show="pickerVisible" class="date-picker-main flex-start">
        <div
          class="date-picker-item"
          v-for="item in dateItems"
          :key="`${item.year}-${item.month}`"
        >
          <div class="date-picker-title">
            {{ item.year }}年{{ item.month }}月
          </div>
          <div class="flex-between table-bottom-border">
            <div class="week-item" v-for="week in weekItems" :key="week">
              {{ week }}
            </div>
          </div>
          <ul class="flex-start flex-wrap" style="height: 216px">
            <li
              class="days-item"
              v-for="(day, index) in item.days"
              :key="`${item.month}-${index}`"
              :ref="dateFormat(`${item.year}-${item.month}-${day}`)"
              :style="{ cursor: day != '' ? 'pointer' : '' }"
              :class="{
                'disabled-item':
                  item.month === currentMonth &&
                  (pickToday ? day > currentDay : day >= currentDay),
              }"
              @click="
                selectDate(
                  item.year,
                  item.month,
                  day,
                  item.month === currentMonth &&
                    (pickToday ? day > currentDay : day >= currentDay)
                )
              "
            >
              {{ day }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <el-button type="default" slot="reference">
      <div class="flex-start align-center">
        <i class="iconfont f18 pt2 mr4">&#xe6c0;</i>
        <span>{{ dateValue }}</span>
        <i class="iconfont f14 ml4">&#xe7f1;</i>
      </div>
    </el-button>
  </el-popover>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "DatePicker",
  props: {
    dateLength: { type: Number, required: true },
    pickToday: { type: Boolean, required: true },
    isCompare: { type: Boolean, required: true },
    // 新增prop，用于隐藏今日实时的选项按钮
    noToday: { type: Boolean, required: false },
    // 计划主页不要实时报表，需要昨日报表，后端已做兼容，该参数只做渲染
    isYesterday: { type: Boolean, required: false },
  },
  data() {
    return {
      popoverVisible: false,
      pickerVisible: false,
      dateValue: "今日实时",
      tempDateValue: "今日实时",
      currentDay: new Date().getDate(),
      currentMonth: new Date().getMonth() + 1,
      weekItems: ["日", "一", "二", "三", "四", "五", "六"],
      dateItems: [],
      activeDate: [],
      activeQuickPicker: 0,
      quickPickerItems: [
        {
          name: this.isYesterday ? "昨日" : (this.isCompare ? "今日实时" : "今天"),
          value: this.isCompare ? 2 : 0,
          flag: false,
        },
        {
          name: "过去3天",
          value: 3,
          flag: true,
        },
        {
          name: "过去7天",
          value: 7,
          flag: true,
        },
        {
          name: "过去15天",
          value: 15,
          flag: true,
        },
        {
          name: "过去30天",
          value: 30,
          flag: true,
        },
        {
          name: "上个月",
          value: 30,
          flag: false,
        },
      ],
      pickResult: [],
    };
  },
  beforeMount() {
    // 某些页面引用该组件时需要隐藏今日实时的选项按钮
    if(this.noToday){
      this.quickPickerItems.shift()
    }
    this.initDatePicker();
    this.quickPickDate(false, 2, 0);
  },
  methods: {
    dateFormat(date) {
      let year = date.split("-")[0],
        month = date.split("-")[1],
        day = date.split("-")[2];
      month = month < 10 ? `0${month}` : month;
      day = day < 10 ? `0${day}` : day;
      return `${year}-${month}-${day}`;
    },
    initDatePicker() {
      let currentMonth = this.currentMonth;
      let currentYear = new Date().getFullYear();
      for (var i = currentMonth; i > currentMonth - this.dateLength; i--) {
        let year = i > 0 ? currentYear : currentYear - 1;
        let month = i > 0 ? i : i + 12;
        let daysArray = [];
        // 这个月总天数
        let currentMonthDays = new Date(new Date(year, month, 1) - 1).getDate();
        // 这个月的第一天是星期几
        let firstDayWeek = new Date(`${year}-${month}-1`).getDay();
        while (firstDayWeek-- > 0) {
          daysArray.unshift("");
        }
        let tempDay = 1;
        while (currentMonthDays-- > 0) {
          daysArray.push(tempDay++);
        }
        let nextMonthDays = 35 - daysArray.length;
        while (nextMonthDays-- > 0) {
          daysArray.push("");
        }
        this.dateItems.unshift({
          year: year,
          month: month,
          days: daysArray,
        });
      }
    },
    selectDate(year, month, day, flag) {
      this.activeQuickPicker = -1;
      if (day != "" && !flag) {
        let date = `${year}-${month}-${day}`;
        date = this.dateFormat(date);
        switch (this.pickResult.length) {
          case 2:
            this.pickResult = [date];
            break;
          default:
            this.pickResult.push(date);
            break;
        }
      } else {
        return false;
      }
      if (this.pickResult.length < 2) {
        this.activeDate = this.pickResult;
        this.tempDateValue = new Date(this.pickResult[0]).format().slice(5, 10);
      } else {
        if (
          this.pickResult.length === 2 &&
          this.pickResult[0] === this.pickResult[1]
        ) {
          this.tempDateValue = new Date(this.pickResult[0])
            .format()
            .slice(5, 10);
        } else {
          let startDate = new Date(this.pickResult[0]).format().slice(5, 10);
          let endDate = new Date(this.pickResult[this.pickResult.length - 1])
            .format()
            .slice(5, 10);
          if (startDate > endDate) {
            this.tempDateValue = `${endDate} 至 ${startDate}`;
          } else {
            this.tempDateValue = `${startDate} 至 ${endDate}`;
          }
        }
        this.getRangeDate();
      }
    },
    quickPickDate(flag, days, index) {
      this.activeQuickPicker = index;
      this.tempDateValue = this.quickPickerItems[index].name;
      let startDate, endDate;
      if (flag) {
        // days为0，直接取这个月日期，否则是以当前日期往前计算days天
        startDate =
          days == 0
            ? new Date(new Date().setDate(1)).format()
            : new Date().calc(days);
        endDate = days == 0 ? new Date().format() : new Date().calc(1);
      } else {
        // 直接取今天、昨天、上个星期或上个月的日期
        var today = new Date().format();
        var yesterday = new Date(
          new Date().getTime() - 24 * 60 * 60 * 1000
        ).format();
        switch (days) {
          case 0:
            startDate = endDate = today;
            break;
          case 1:
            startDate = endDate = yesterday;
            break;
          case 2:
            startDate = yesterday;
            endDate = today;
            break;
          case 7:
            var currentTime = new Date().getTime();
            var currentDay = new Date().getDay();
            var beforeWeekList = [];
            for (var i = 0; i < 7; i++) {
              var time =
                currentTime - (currentDay + (7 - 1 - i)) * 24 * 60 * 60 * 1000;
              beforeWeekList[i] = new Date(time).format();
            }
            startDate = beforeWeekList[0];
            endDate = beforeWeekList[6];
            break;
          case 30:
            var lastMonth = new Date().getMonth();
            if (lastMonth === 0) {
              startDate = new Date(
                `${new Date().getFullYear() - 1}-12-01`
              ).format();
            } else {
              startDate = new Date(
                `${new Date().getFullYear()}-${new Date().getMonth()}-01`
              ).format();
            }
            endDate = new Date(new Date().setDate(0)).format();
            break;
        }
      }
      this.pickResult = [startDate, endDate];
      this.getRangeDate();
    },
    getRangeDate() {
      let startUnix = new Date(this.pickResult[0]).getTime();
      let endUnix = new Date(this.pickResult[1]).getTime();
      if (startUnix > endUnix) {
        let tempUnix = startUnix;
        startUnix = endUnix;
        endUnix = tempUnix;
      }
      let result = [];
      for (var m = startUnix; m <= endUnix; ) {
        let date = new Date(parseInt(m));
        result.push(
          this.dateFormat(
            `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
          )
        );
        m += 24 * 60 * 60 * 1000;
      }
      this.activeDate = result;
    },
    submitPickResult() {
      let startDate = new Date(this.activeDate[0]).format();
      let endDate = new Date(
        this.activeDate[this.activeDate.length - 1]
      ).format();
      let type;
      if (
        startDate === new Date(new Date().calc(1)).format() &&
        endDate === new Date().format()
      ) {
        type = "compare";
      } else {
        type = "history";
      }
      this.dateValue = this.tempDateValue;
      this.popoverVisible = false;
      this.$emit("emitDateRes", [startDate, endDate, type]);
    },
  },
  watch: {
    activeDate(newVal) {
      for (var i in this.$refs) {
        if (newVal.indexOf(i) !== -1) {
          this.$refs[i][0].classList.add("active-days");
        } else {
          this.$refs[i][0].classList.remove("active-days");
        }
      }
    },
  },
  computed: {
    ...mapState(["activeTheme"]),
  },
};
</script>

<style lang="scss">
.el-popover__reference-wrapper {
  margin-top: 4px;
}
.date-popover {
  padding: 20px;

  .popover-title {
    color: $base-gray;
    font-size: 12px;
    margin-bottom: 8px;
  }

  .quick-picker-item {
    width: 85px;
    height: 26px;
    text-align: center;
    line-height: 26px;
    margin-bottom: 8px;
    cursor: pointer;
    border-radius: 4px;
  }

  .date-picker-main {
    position: absolute;
    top: -1px;
    right: 2px;
    margin-right: 100%;
    background: #fff;
    border: 1px solid $base-border;
    border-radius: 4px;

    .date-picker-item {
      font-size: 12px;
      width: 252px;
      padding: 9px 5px 0 5px;
      border-right: 1px solid $base-table-border;

      &:last-child {
        border-right: 0;
      }

      .date-picker-title {
        text-align: center;
      }

      .week-item,
      .days-item {
        width: 24px;
        height: 24px;
        margin: 6px;
        text-align: center;
        line-height: 24px;
        border-radius: 50%;
      }

      .disabled-item {
        cursor: not-allowed !important;
        background: $base-disabled-backgroud;
      }
    }
  }
}

.active-quick-picker {
  @include theme-color();
  @include theme-background-10();
}

.active-days {
  @include theme-background();
  color: #fff;
}
</style>
